import React from 'react';

import Grid from '@material-ui/core/Grid';
import Drawer from '../components/Drawer'

import Header from '../components/Header'
import ConnectedHector from '../containers/ConnectedHector';

import '../styles/drawer.css'

const Main = ({drawer, closeDrawer, openDrawer}) => {

    return (
        <div>
            <Drawer open={drawer.open} content={drawer.content} onClick={ () => closeDrawer(drawer.content)}/>
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="stretch"
            >
                <Grid item>
                    <Header></Header>
                </Grid>
                <Grid item>
                    <ConnectedHector></ConnectedHector>
                </Grid>
                <Grid item>
                    <p className="rights">All rights reserved. Hector R. Acosta © {new Date().getFullYear()}</p>
                </Grid>
            </Grid>
        </div>
    );
}

export default Main


// WEBPACK FOOTER //
// ./src/components/Main.jsx